// Scroll Monitor
window.scrollr = require("scrollMonitor")

// Floating Tabs
var $floatbar = $('#floatbar .wapper'),
  $parent = $floatbar.parent();
  $parent.height($parent.height());
  $floatbar.find('.wapper').width($floatbar.width());

// Floatbar watcher
var fbWatcher = scrollr.create($floatbar);
fbWatcher.lock();
fbWatcher.stateChange(function () {
  $floatbar.toggleClass('abfix', this.isAboveViewport)
});
if (fbWatcher.isAboveViewport) {
  $floatbar.addClass('abfix');
}

// Tab watcher
$floatbar.find('ul li a').each(function () {
  var tabbtn = $(this),
    tabid = tabbtn.attr('href'),
    fheight = $floatbar.parent().height(),
    tabWatcher = scrollr.create(tabid, {
      top: fheight + 20,
      bottom: -fheight
    });

  // Highlight when scroll
  tabWatcher.stateChange(function () {
    var tabli = tabbtn.parent();
    if (!tabWatcher.isInViewport) {
      tabli.removeClass('active');
    } else if (tabWatcher.isInViewport && tabWatcher.isAboveViewport) {
      tabli.addClass('active');

      // // Slide to active tab
      // let index = tabli.data("index");
      // $floatbar.find('.slider-tab').slick('slickGoTo', index);
    } else {
      tabli.removeClass('active');
    }
  });
});

// Click to scroll
$floatbar.find('ul li a').click(function () {
  var tabid = $(this).attr('href'),
    fheight = $floatbar.parent().height(),
    top = $(tabid).offset().top - (fheight - 30);
  if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) window.scrollTo(0, top);
  else $("html,body").animate({ scrollTop: top }, 900);
  return false;
});



// WEBPACK FOOTER //
// ./src/about.js